import { render, staticRenderFns } from "./TgCjCompetition.vue?vue&type=template&id=0d14e7d6&"
import script from "./TgCjCompetition.vue?vue&type=script&lang=js&"
export * from "./TgCjCompetition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports